module.exports = __webpack_public_path__ + "img/hot_bg.e82aa5e.png";